import { Routes } from '@angular/router';

import { AuthGuard, CheckLoggedInGuard, PermissionGuard, UserPermission } from '@eiq/auth';

import { defaultRoutes, defaultRouteResolver } from './utils/default-routes';

import { environment } from '../environments/environment';

const unAuthorizedBackRoute = 'sign-in';

const researchAssistantRoutes: Routes = environment.researchAssistantEnabled
  ? [
      {
        path: 'insight-navigator',
        canActivate: [AuthGuard],
        data: { redirectUrl: unAuthorizedBackRoute },
        loadChildren: () => import('@empathy/research-assistant/feature').then((m) => m.ResearchAssistantRoutes)
      }
    ]
  : [];

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'sign-in',
    pathMatch: 'full'
  },
  {
    path: 'home',
    redirectTo: 'sign-in',
    pathMatch: 'full'
  },
  {
    path: 'sign-in',
    canActivate: [CheckLoggedInGuard],
    data: { defaultRoutes, unauthorizedRoute: 'access-forbidden' },
    loadChildren: () => import('@eiq/sign-in').then((m) => m.UserSignInModule)
  },
  {
    path: 'panel-members',
    canActivate: [AuthGuard, PermissionGuard],
    data: { permissions: [UserPermission.ManagePanels] },
    children: [
      {
        path: 'management',
        loadChildren: () => import('@eiq/panel-members/management').then((m) => m.PanelistRoutes)
      },
      {
        path: 'registrations',
        loadChildren: () => import('@eiq/panel-members/registrations').then((m) => m.PanelMemberRegistrationsRoutes)
      },
      {
        path: 'rewards',
        loadChildren: () => import('@mom/rewards/admin').then((m) => m.RewardsRedemptionModule)
      },
      {
        path: '',
        redirectTo: '/panel-members/management',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'panels',
    canActivate: [AuthGuard, PermissionGuard],
    data: { permissions: [UserPermission.ManagePanels] },
    loadChildren: () => import('@eiq/panels/feature').then((m) => m.PanelsModule)
  },
  {
    path: 'polls',
    canActivate: [AuthGuard, PermissionGuard],
    data: { permissions: [UserPermission.ManagePolls] },
    loadChildren: () => import('@eiq/polls/admin').then((m) => m.AdminPollModule)
  },
  {
    path: 'projects',
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissions: [UserPermission.ManageProjects, UserPermission.EditProjects, UserPermission.ViewProjects, UserPermission.ViewProjectsPrelaunch]
    },
    loadChildren: () => import('@eiq/projects/feature').then((m) => m.ProjectsModule)
  },
  {
    path: 'usage',
    canActivate: [AuthGuard, PermissionGuard],
    data: { permissions: [UserPermission.ViewUsage] },
    loadComponent: () => import('@eiq/tenant/usage').then((m) => m.TenantUsageDashboardPage)
  },
  {
    path: 'trust-centre',
    canActivate: [AuthGuard, PermissionGuard],
    data: { permissions: [UserPermission.ViewTrustCentre] },
    loadComponent: () => import('@eiq/trust/trust-centre').then((m) => m.TrustCentrePage)
  },
  {
    path: 'settings',
    canActivate: [AuthGuard, PermissionGuard],
    data: { permissions: [UserPermission.ManageSystemSettings] },
    loadComponent: () => import('@eiq/tenant/settings').then((m) => m.TenantSettingsPage)
  },
  {
    path: 'users-management',
    canActivate: [AuthGuard, PermissionGuard],
    data: { permissions: [UserPermission.ManageUsers, UserPermission.ViewUsers] },
    loadChildren: () => import('@eiq/users/user-management').then((m) => m.UsersManagementModule)
  },
  {
    path: 'clients',
    canActivate: [AuthGuard, PermissionGuard],
    data: { permissions: [UserPermission.ManageClients] },
    loadChildren: () => import('@eiq/clients/management').then((m) => m.ClientsRoutes)
  },
  {
    path: 'client-brief-requests',
    canActivate: [AuthGuard],
    loadChildren: () => import('@eiq/clients/management').then((m) => m.ClientBriefRequestsRoutes)
  },
  ...researchAssistantRoutes,
  {
    path: 'not-found',
    loadChildren: () => import('@empathy/error/not-found').then((m) => m.EmpathyNotFoundModule),
    data: { homeUrl: '/projects', navigateActions: true, searchActions: true, isPrivate: true }
  },
  {
    path: 'access-forbidden',
    loadComponent: () => import('@empathy/error/access-forbidden').then((m) => m.AccessForbiddenPage),
    resolve: { homeUrl: defaultRouteResolver }
  },
  {
    path: '**',
    redirectTo: '/not-found'
  }
];
